// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eO4JGdSNUmzwulwvfe_u {
  height: 100%;
}
.zSBZsqv2GEG2ktkDrhzs {
  background: #fff;
  height: 100%;
}
.Kt41Bg8Wi_fovQ2V3Ntz {
  background: #f7f8f9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrgDashboard/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;AAGA;EACE,gBAAA;EACA,YAAA;AADF;AAIA;EACE,mBAAA;AAFF","sourcesContent":["\n.container {\n  height: 100%;\n}\n\n.sidebar {\n  background: #fff;\n  height: 100%;\n}\n\n.content {\n  background: #f7f8f9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `eO4JGdSNUmzwulwvfe_u`,
	"sidebar": `zSBZsqv2GEG2ktkDrhzs`,
	"content": `Kt41Bg8Wi_fovQ2V3Ntz`
};
export default ___CSS_LOADER_EXPORT___;
